import React from 'react';

const data = [
  { name: "Raspberry Pi 5 8GB", cost: "$79.99", units: 2 },
  { name: "Raspberry Pi 5 16 GB", cost: "$144,99", units: 1 },
  { name: "Raspberry Pi Zero 2W H", cost: "$19.99", units: 1 },
  { name: "Raspberry Pi Zero 2W", cost: "$14.99", units: 1 },
  { name: "Nvidia T1000", cost: "EWASTE", units: 1 },
  { name: "Raspberry Pi AI KIT", cost: "$79.99", units: 1 },
  { name: "Raspberry Pi AI CAM", cost: "$69.99", units: 1 },
  { name: "Raspberry Pi Active Cooler", cost: "$9.99", units: 1 },
  { name: "Geekworm X1015 PCIE to M.2", cost: "$15.95", units: 2 },
  { name: "Geekworm P579 Case", cost: "$12.95", units: 2 },
  { name: "Geekworm X306 Case", cost: "$11.95", units: 1 },
  { name: "Geekworm PSU60 60W", cost: "$19.95", units: 1 },
  { name: "PWM case for Raspberry Pi", cost: "$15.95", units: 1 },
  { name: "27W USB-C PD", cost: "$8.95", units: 1 },
  { name: "iUniker 27W PD USB-C", cost: "$13.99", units: 1 },
  { name: "Geekworm Raspberry Pi Zero 2w heatsink", cost: "$7.00", units: 1 },
];


function Proj1() {
    return (
        generateTable(data)
    );
}

function generateTable(data){
    return (
    <div id="contentsection1">
        <h1 id="projHeader">
            Raspberry Pi Parts"
        </h1>
        <table id="projTable">
            <tr>
                <th id="projTable">name</th>
                <th id="projTable">cost</th>
                <th id="projTable">units</th>
            </tr>
            {data.map((row, i) => (
                <tr>
                    <td id="projTable">{row.name}</td>
                    <td id="projTable">{row.cost}</td>
                    <td id="projTable">{row.units}</td>
                </tr>
            ))}
        </table>
    </div>
    )
}

export default Proj1;
